import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FloatingUploadPreviewPanelComponent } from './floating-upload-preview-panel.component';

@NgModule({
  declarations: [FloatingUploadPreviewPanelComponent],
  imports: [CommonModule, MatIconModule],
  exports: [FloatingUploadPreviewPanelComponent],
})
export class FloatingUploadPreviewPanelModule {}
